// Generated by ReScript, PLEASE EDIT WITH CARE


function getMarkerRotation(rotationVariant) {
  switch (rotationVariant) {
    case /* Left */0 :
        return -45;
    case /* Right */1 :
        return 45;
    case /* Straight */2 :
        return 0;
    
  }
}

export {
  getMarkerRotation ,
  
}
/* No side effect */
